import FormControl from '@mui/material/FormControl'
import InputLabel from '@mui/material/InputLabel'
import MenuItem from '@mui/material/MenuItem'
import Select from '@mui/material/Select'
import TableSortLabel from '@mui/material/TableSortLabel'

import { FormattedMessage } from 'react-intl'
import { MofiSortType, SortDirectionDTO } from '../../apis'
import { PaginationAndSortingValues } from '../moovyPagination'

type MoovySortAndFilterProps = {
  sortOptions: { key: string; value: string }[]
  defaultSortCriteria: MofiSortType
  pt?: number
  pb?: number
  paginationAndSortingValues: PaginationAndSortingValues
  setPaginationAndSortingValues: (
    paginationAndSortingValues: PaginationAndSortingValues,
  ) => void
}
const MoovySortControl = ({
  sortOptions: items,
  pt,
  pb,
  paginationAndSortingValues,
  setPaginationAndSortingValues,
}: MoovySortAndFilterProps) => {
  const updatePaginationAndSortingValues = (params: {
    sortCriteria?: MofiSortType
    sortDirection?: SortDirectionDTO
  }) => {
    setPaginationAndSortingValues({
      ...paginationAndSortingValues,
      sort: params.sortCriteria ?? paginationAndSortingValues.sort,
      direction: params.sortDirection ?? paginationAndSortingValues.direction,
    })
  }

  return (
    <>
      <FormControl fullWidth size="small" sx={{ minWidth: '8rem' }}>
        <InputLabel id="moovy-sort-and-filter-select-label">
          <FormattedMessage id="sortControl.sortingCriteria" />
        </InputLabel>
        <Select
          labelId="moovy-sort-control-select-label"
          id="moovy-sort-control-select"
          label={<FormattedMessage id="sortControl.sortingCriteria" />}
          value={paginationAndSortingValues.sort}
          onChange={(event) => {
            updatePaginationAndSortingValues({
              sortCriteria: (event.target as HTMLInputElement)
                .value as MofiSortType,
            })
          }}
        >
          {items.map((item, index) => (
            <MenuItem key={index} value={item.key}>
              {item.value}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
      <TableSortLabel
        active={true}
        direction={
          paginationAndSortingValues.direction === 'ASC' ? 'asc' : 'desc'
        }
        onClick={() => {
          updatePaginationAndSortingValues({
            sortDirection:
              paginationAndSortingValues.direction === 'ASC' ? 'DESC' : 'ASC',
          })
        }}
      >
        <FormattedMessage
          id={
            paginationAndSortingValues.direction === 'ASC'
              ? 'sortDirection.ASC'
              : 'sortDirection.DESC'
          }
        />
      </TableSortLabel>
    </>
  )
}

export default MoovySortControl
